import ConfigManager from '@/config/ConfigManager.js'
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

export default {

    /**
     * @param {RegisterModel} params /module/Register/model/RegisterModel.js
     */
    apiValidateRegister: function (params) {
        params.app_id = ConfigManager.getAppId();
        let url = ConfigManager.getApiUrl() + '/auth/validate_register';
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => {
            return res.data;
        }));
    },

    apiValidateOtpRegister: function (params) {
        let url = ConfigManager.getApiModuleUrl() + '/auth/validate_otp';
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * @param {RegisterModel} params /module/Register/model/RegisterModel.js
     */
    apiRegister: function (params) {
        params.app_id = ConfigManager.getAppId();
        let url = ConfigManager.getApiUrl() + '/auth/register';
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => {
            return res.data;
        }));
    },
}
